import { startCase, toLower } from 'lodash-es';

export const convertToTitle = (s) => startCase(toLower(s))